import { heroKeywords, heroStats, tickerItems } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full pt-16 bg-background-50 overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(900px 520px at 88% 12%, oklch(var(--primary-100) / 0.6), transparent 60%), radial-gradient(700px 460px at 6% 82%, oklch(var(--accent-100) / 0.55), transparent 62%)",
        }}
        aria-hidden="true"
      ></div>

      <div className="relative w-full px-4 md:px-8 pt-10 md:pt-16 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="animate-rise">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 border border-secondary-200">
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              <span className="font-label text-xs text-secondary-900">
                技术向 · 照片真假鉴定室
              </span>
            </div>

            <h1 className="font-heading font-black text-foreground-950 mt-5 leading-[1.1] text-4xl md:text-5xl lg:text-6xl">
              黑料照片
              <span className="block mt-3 text-lg md:text-2xl font-bold text-primary-600">
                P图鉴定 · 真假分析 · 辟谣对照
              </span>
            </h1>

            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700 max-w-xl">
              针对流传的黑料照片做技术向拆解：查 P 图痕迹、比对光影方向、放大原始像素，
              再逐条做辟谣对照。每个争议照片都附详细疑点讨论，帮你分清哪些是实锤、哪些是伪造。
            </p>

            <div className="flex flex-wrap gap-2 mt-5">
              {heroKeywords.map((kw) => (
                <span
                  key={kw}
                  className="font-label text-xs px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-foreground-700"
                >
                  {kw}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 mt-7">
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line"></i>
                <span className="text-sm font-medium">查看今日热度榜</span>
              </a>
              <a
                href="#submit"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-foreground-300 text-foreground-900 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-upload-2-line"></i>
                <span className="text-sm font-medium">提交照片鉴定</span>
              </a>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-9 pt-7 border-t border-background-200">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <div className="font-heading font-black text-2xl md:text-3xl text-foreground-950">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-600 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative animate-rise" style={{ animationDelay: "120ms" }}>
            <div className="relative w-full h-[420px] md:h-[560px] rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Moody%20forensic%20investigation%20desk%20with%20printed%20photographs%20pinned%20to%20a%20dark%20cork%20board%2C%20a%20large%20brass%20magnifying%20glass%20resting%20on%20top%2C%20delicate%20pixel%20grid%20overlays%20drawn%20in%20red%20ink%2C%20warm%20amber%20desk%20lamp%20glow%2C%20deep%20shadows%2C%20stylized%20editorial%20photography%2C%20clean%20restrained%20composition%2C%20high%20detail&width=900&height=1100&seq=heiliiao-hero-verdict-01&orientation=portrait"
                alt="黑料照片技术鉴定工作台，照片、放大镜与像素网格"
                title="黑料照片鉴定工作台"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>

              <div className="absolute top-4 left-4 flex items-center gap-2 px-3 py-1.5 rounded-md bg-background-50/90 backdrop-blur">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span className="font-label text-xs text-foreground-800">
                  正在鉴定 · 12 张待核
                </span>
              </div>

              <div className="absolute bottom-4 left-4 right-4 rounded-md bg-background-50/95 backdrop-blur border border-background-200 p-4">
                <div className="flex items-center justify-between gap-3">
                  <div className="min-w-0">
                    <div className="font-label text-[11px] text-foreground-500">
                      最新鉴定结论
                    </div>
                    <div className="font-heading font-bold text-sm md:text-base text-foreground-950 mt-1 truncate">
                      某后台合影 → 双人拼接
                    </div>
                  </div>
                  <span className="shrink-0 font-label text-xs px-3 py-1.5 rounded-full bg-primary-500 text-background-50">
                    判定 伪造
                  </span>
                </div>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> 12.4 万
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i> 1,286 讨论
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-checkbox-circle-line"></i> 已被 38 人复核
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative w-full bg-secondary-900 overflow-hidden">
        <div className="flex w-max animate-ticker">
          {[...tickerItems, ...tickerItems].map((item, idx) => (
            <div
              key={`${item}-${idx}`}
              className="flex items-center gap-3 px-6 py-3 whitespace-nowrap"
            >
              <i className="ri-flashlight-fill text-accent-400"></i>
              <span className="font-label text-xs md:text-sm text-secondary-100">
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}